module.exports = __webpack_public_path__ + "static/media/instagram.8630a115.svg";